import {
  ComponentProps,
  createContext,
  FC,
  ReactElement,
  useContext,
  useReducer
} from 'react';
import {
  selectedDicomReducer,
  initialSelectedDicomState
} from '@shared/context/reducers/SelectedDicomReducer';
import {
  setSelectedDicom,
  removeSelectedDicom,
  clearSelectedDicom
} from '@shared/context/actions/SelectedDicomActions';
import {SelectedDicomModel} from '@shared/context/mappers/SelectedDicomTypesMapper';

interface SelectedDicomInterface {
  readonly SelectedDicomState: SelectedDicomModel;
  readonly setSelectedDicomData: (data: object) => void;
  readonly removeSelectedDicomData: (data: object) => void;
  readonly clearSelectedDicomData: (data?: object) => void;
}

const SelectedDicomContext = createContext<SelectedDicomInterface>(
  {} as SelectedDicomInterface
);

export const useSelectedDicomContext = (): SelectedDicomInterface =>
  useContext(SelectedDicomContext);

export const SelectedDicomProvider = ({
  children
}: ComponentProps<FC<any>> & {children: ReactElement}): JSX.Element => {
  const [SelectedDicomState, dispatch] = useReducer(
    selectedDicomReducer,
    initialSelectedDicomState
  );

  const setSelectedDicomData = (data: any): void => {
    setSelectedDicom(dispatch, data);
  };

  const removeSelectedDicomData = (data: any): void => {
    removeSelectedDicom(dispatch, data);
  };

  const clearSelectedDicomData = (data: any): void => {
    clearSelectedDicom(dispatch, data);
  };

  return (
    <SelectedDicomContext.Provider
      value={{
        SelectedDicomState,
        setSelectedDicomData,
        removeSelectedDicomData,
        clearSelectedDicomData
      }}>
      {children}
    </SelectedDicomContext.Provider>
  );
};
